import { AfterViewInit, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { createPointEditorForm } from './map-point-editor-form';
import type { MapPointDraft, MapPointEditorResult } from './map-point.models';
export {
  MAP_POINT_AREA_HA,
  MAP_POINT_MAX_AREA_HA,
  pointAreaHa,
  pointAreaLabel,
  withPointArea,
} from './map-point.models';
export type { MapPointDraft, MapPointEditorResult } from './map-point.models';

@Component({
  imports: [MatDialogModule],
  template: '<mat-dialog-content style="padding:21px 16px"><div #formHost></div></mat-dialog-content>',
})
export class MapPointEditorComponent implements AfterViewInit {
  private readonly data = inject<MapPointDraft>(MAT_DIALOG_DATA);
  private readonly ref = inject(MatDialogRef<MapPointEditorComponent, MapPointEditorResult>);
  private readonly translate = inject(TranslateService);
  @ViewChild('formHost', { static: true }) private readonly formHost!: ElementRef<HTMLElement>;

  ngAfterViewInit() {
    const form = createPointEditorForm(
      this.data,
      (key) => this.translate.instant(key),
      (result) => this.ref.close(result)
    );
    form.style.padding = '0';
    this.formHost.nativeElement.appendChild(form);
  }
}
